import React from 'react'
import ShapesSection from './ShapesSection'
import ShapeThumbItem from './ShapeThumbItem'

const DraftShapesSection = ({
    items,
    loading,
    skeletonCount,
    pagination,
    title = 'Draft Shapes',
    emptyComponent,
    onSelectDraft,
    onEditDraft,
    onDeleteDraft,
}) => {
    return (
        <ShapesSection
            title={title}
            loading={loading}
            items={items}
            skeletonCount={skeletonCount}
            pagination={pagination}
            emptyComponent={emptyComponent}
            renderItem={(draft) => (
                <ShapeThumbItem
                    item={draft}
                    itemKey={draft.id}
                    ariaLabel="Draft shape"
                    onClick={onSelectDraft}
                    onDelete={onDeleteDraft}
                    deleteAriaLabel="Delete draft"
                    actions={
                        typeof onEditDraft === 'function'
                            ? [
                                  {
                                      key: 'edit',
                                      className: 'SidebarPanel__ShapeThumbAction SidebarPanel__ShapeThumbAction--edit',
                                      onAction: onEditDraft,
                                      ariaLabel: 'Edit draft',
                                      content: 'Edit',
                                  },
                              ]
                            : []
                    }
                >
                    {draft.previewUrl ? (
                        <img src={draft.previewUrl} alt="" className="SidebarPanel__ShapeThumbImg" />
                    ) : (
                        <span className="SidebarPanel__ShapeThumbPlaceholder">Draft</span>
                    )}
                </ShapeThumbItem>
            )}
        />
    )
}

export default DraftShapesSection
